<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item :label="$locale('setting.cinema.entrance.start')" prop="cinemaSetting.scanStartMin" :rules="formRules.scanStartMin">
      <el-input :placeholder="$locale('setting.cinema.p.minutes')" v-model.number="detailObj.cinemaSetting.scanStartMin" :disabled="!editable" maxlength="5"></el-input>
    </el-form-item>
    <el-row :gutter="20">
      <el-col :span="12">
        <el-form-item :label="$locale('setting.cinema.entrance.end')" prop="cinemaSetting.scanEndMin" :rules="formRules.scanEndMin">
          <el-input :placeholder="$locale('setting.cinema.p.minutes')" v-model.number="detailObj.cinemaSetting.scanEndMin" :disabled="!editable" maxlength="5"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="12" style="margin-top: 40px;">
        <el-radio-group v-model="detailObj.cinemaSetting.scanEndType">
          <el-radio label="startTime">上映開始時間から〇分後</el-radio>
          <el-radio label="endTime">上映終了時間から〇分前</el-radio>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="8">
        <el-form-item label="入場時間が過ぎかつ入場済みの場合の提示メッセージ表示" prop="cinemaSetting.scanOrderType">
          <el-select v-model="detailObj.cinemaSetting.scanOrder" style="width: 250px;">
            <el-option label="入場時間が過ぎました" value="passed"></el-option>
            <el-option label="入場済み" value="admission"></el-option>
          </el-select>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "cinemaEntranceSetting",
  props: {
    detailObj: Object,
  },
  data() {
    return {
      editable: true,
      action: "create",
      formRules: {
        scanStartMin: [
          {
            required: true,
            message: this.$locale("setting.cinema.entrance.err.start"),
            trigger: "blur",
          },
          {
            type: "number",
            message: this.$locale("form.mustFillInNum"),
            trigger: "blur",
          },
        ],
        scanEndMin: [
          {
            required: true,
            message: this.$locale("setting.cinema.entrance.err.end"),
            trigger: "blur",
          },
          {
            type: "number",
            message: this.$locale("form.mustFillInNum"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {},
};
</script>
